import { apiDaInscricao } from "../../../servicos/axios";

export interface CriarProjetoPayload {
  nome: string;
  idPrograma: number;
  descricao: string;
  dataInicio?: string | null;
  dataFim?: string | null;
  textoDeCiencia: string;
}

export const criarProjeto = async (payload: CriarProjetoPayload) => {
  const response = await apiDaInscricao().post("/projeto/criar", payload);
  return response.data;
};
